import { useState, useEffect } from "react";
import UpperLayerTabLayout from "../../../Components/DetailsPageUpperLayer/UpperLayerTabLayout";

const OutboundDeliveryHeader = ({ hProps }) => {
  const [deliveryDetails, setDeliveryDetails] = useState({});
  const [freightDetails, setFreightDetails] = useState({});

  const fieldLabels = {
    lob: "LOB",
    erpHeaderStatus: "ERP Header Status",
    eta: "ETA",
    ata: "ATA"
  };

  // Function to seed data with defaults (null in this case)
  const seedWithDefaults = (src, keys) =>
    keys.reduce((acc, k) => {
      acc[k] = src?.[k] ?? null; // Default to null, can be adjusted to other defaults (like "TBD")
      return acc;
    }, {});

  useEffect(() => {
    // Define the keys for Delivery
    const deliveryKeys = [
      "deliveryNo",
      "deliveryType",
      "lob",
      "supplier",
      "supplierName",
      "customer",
      "customerName",
      "eta",
      "ata",
      "creationDate",
      // "palletNo",
      // "highLevelItem",
      "erpHeaderStatus",
      // "packingSlipNo",
      "shippingPoint",
      // "comments",
    ];

    // Define the keys for Freight
    const freightKeys = [
      "shipmentNo",
      "shipmentLineNo",
      // "truckNo",
      // "trailerNo",
      "shipFrom",
      "shipFromOwner",
      "shipFromSite",
      "shipTo",
      "shipToOwner",
      "shipToSite",
      "shipMode",
      "plannedShipDate",
      "actualShipDate",
      // "bolNo",
      // "hawbNo",
      "carrier"
    ];

    // Seed the data with default values (null) for both delivery and freight
    let deliveryObj = seedWithDefaults(hProps || {}, deliveryKeys);
    let freightObj = seedWithDefaults(hProps || {}, freightKeys);

    // Set default data in the state
    setDeliveryDetails(deliveryObj);
    setFreightDetails(freightObj);
  }, [hProps]); // Trigger this effect when hProps changes

  return (
    <UpperLayerTabLayout
      firstHeading="Delivery"
      secondHeading="Freight"
      firstBoxData={deliveryDetails}  // Display delivery details
      secondBoxData={freightDetails}  // Display freight details
      title="Outbound Deliveries Detail"
      showThirdTab={false}  // No third tab for Track & Trace
      showTrackAndTrace={true}  // Enable Track & Trace
      fkLink={hProps?.fkLink}
      fieldLabels={fieldLabels}
    />
  );
};

export default OutboundDeliveryHeader;
